(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter =
          !isLargeScreen &&
          window.location.hash === '#footer-signup_form' &&
          this.querySelector('#footer-signup_form') !== null;

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["manola-purchase-reminder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('manola-purchase')) {
  customElements.define('manola-purchase', class extends HTMLElement {
    connectedCallback() {
      this.action = this.querySelector('[data-purchase-action]');
      this.main = document.querySelector('.product-main .product-info');
      if (!this.action || !this.main) return;
      this.sync = this.sync.bind(this);
      this.activate = this.activate.bind(this);
      this.action.addEventListener('click', this.activate);
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.main, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'hidden'] });
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.action?.removeEventListener('click', this.activate);
    }
    sync() {
      const add = this.main.querySelector('.js-product-form-main [name="add"]');
      const notify = this.main.querySelector('.restock-rocket-button-product');
      const busy = add?.getAttribute('aria-disabled') === 'true';
      const notifyVisible = notify && notify.getClientRects().length > 0;
      this.action.textContent = notifyVisible ? this.dataset.notify : add?.disabled ? (this.dataset.available === 'false' ? this.dataset.notify : this.dataset.options) : (add?.textContent.trim() || this.dataset.options);
      this.action.setAttribute('aria-disabled', busy ? 'true' : 'false');
      const price = this.main.querySelector('.price__current');
      if (price) this.querySelector('.manola-purchase__price').innerHTML = price.innerHTML;
      const error = this.main.querySelector('.js-form-error:not([hidden])');
      this.querySelector('.manola-purchase__status').textContent = error?.textContent.trim() || '';
    }
    activate(event) {
      event.preventDefault();
      if (this.action.getAttribute('aria-disabled') === 'true') return;
      const notify = this.main.querySelector('.restock-rocket-button-product');
      if (notify && notify.getClientRects().length > 0) {
        notify.click();
        return;
      }
      const add = this.main.querySelector('.js-product-form-main [name="add"]');
      const form = add?.form;
      const customInput = form?.querySelector('input[type="file"],[name^="properties["]');
      if (!add || add.disabled || customInput) {
        this.main.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        (this.main.querySelector('variant-picker input,variant-picker select,input[type="file"]') || add)?.focus({ preventScroll: true });
        return;
      }
      add.click();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["manola-reels"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('manola-reels')) {
    customElements.define('manola-reels', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.track = this.querySelector('.manola-reels__track');
        this.previous = this.querySelector('[data-reel-prev]');
        this.next = this.querySelector('[data-reel-next]');
        this.counter = this.querySelector('[data-reel-count]');
        this.previous.addEventListener('click', () => this.move(-1));
        this.next.addEventListener('click', () => this.move(1));
        this.track.addEventListener('scroll', () => this.update(), {passive:true});
        this.addEventListener('click', event => {
          const trigger = event.target.closest('[data-reel-open]');
          if (trigger) {
            const dialog = this.querySelector('#' + CSS.escape(trigger.dataset.reelOpen));
            dialog.showModal();
            dialog.querySelector('video').play().catch(() => {});
          }
          if (event.target.closest('[data-reel-close]')) event.target.closest('dialog').close();
        });
        this.querySelectorAll('dialog').forEach(dialog => {
          dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
          dialog.addEventListener('close', () => { dialog.querySelector('video').pause(); });
        });
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.track);
        this.update();
      }
      disconnectedCallback() { this.observer?.disconnect(); this.bound = false; }
      move(direction) {
        const card = this.track.querySelector('article');
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap);
        this.track.scrollBy({left:direction * step, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }
      update() {
        const cards = Array.from(this.track.querySelectorAll('article'));
        const left = this.track.scrollLeft;
        this.previous.disabled = left < 3;
        this.next.disabled = left >= this.track.scrollWidth - this.track.clientWidth - 3;
        const nearest = cards.reduce((best, card, index) => Math.abs(card.offsetLeft - cards[0].offsetLeft - left) < Math.abs(cards[best].offsetLeft - cards[0].offsetLeft - left) ? index : best, 0);
        this.counter.textContent = (nearest + 1) + ' / ' + cards.length;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["manola-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('manola-review-marquee')) {
  customElements.define('manola-review-marquee', class extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      this.viewport = this.querySelector('.manola-reviews__viewport');
      this.group = this.querySelector('.manola-reviews__group');
      if (!this.viewport || !this.group || !this.group.children.length) return;
      this.resizeObserver = new ResizeObserver(() => this.updateDuration());
      this.resizeObserver.observe(this.group);
      this.updateDuration();
      this.classList.add('is-ready');
      this.viewport.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse') this.setPaused(!this.classList.contains('is-paused'));
      }, options);
      this.addEventListener('shopify:block:select', () => this.classList.add('is-editing'), options);
      this.addEventListener('shopify:block:deselect', () => this.classList.remove('is-editing'), options);
      this.visibilityObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => this.classList.toggle('is-offscreen', !entry.isIntersecting));
      });
      this.visibilityObserver.observe(this);
    }
    updateDuration() {
      const speed = Math.max(15, Math.min(60, Number(this.dataset.speed) || 30));
      this.style.setProperty('--mr-duration', (this.group.getBoundingClientRect().width / speed) + 's');
    }
    setPaused(paused) {
      this.classList.toggle('is-paused', paused);
    }
    disconnectedCallback() {
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
      this.visibilityObserver?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
